import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, CloseButton, Text } from '..';
import { SearchOptionProps } from './Search.types';
import { useRecentSearches } from '../../../utils/hooks/useRecentSearches';

export const DefaultSearchOption: FC = () => {
  return (
    <Box paddingTop={1}>
      <Text
        weight={'bold'}
        size={'small'}
        secondary
        light
      >
        <FormattedMessage id={'search.results.recent-searches'} />
      </Text>
    </Box>
  )
}

export const SearchOption: FC<SearchOptionProps> = ({ id, title, hovered }) => {
  const { deleteRecentSearch } = useRecentSearches();
  const handleDelete = (event) => {
    event.stopPropagation();

    deleteRecentSearch(id);
  }
  
  return (
    <Box
      width='100%'
      align='space-between'
    >
      <Text weight={'thin'} dataHook='search-option'>{title}</Text>

      {hovered && (
        <CloseButton
          skin='dark'
          size='medium'
          dataHook='delete-search'
          onClick={handleDelete}
        />
      )}
    </Box>
  )
}